import type { OtherAsset } from "~/types/assets.types";

export const calculateOtherYears = (userProduct: OtherAsset) => {
  const purchaseDate = userProduct?.purchaseDate || "";
  const currentDate = new Date();
  const purchasingDate = new Date(purchaseDate);

  return currentDate.getFullYear() - purchasingDate.getFullYear() || 0;
};
